import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default function initFeatureBlocks() {
  // Kill any existing feature-block ScrollTriggers in case of re-init.
  ScrollTrigger.getAll().forEach(trigger => {
    if (trigger.vars && trigger.vars.trigger && trigger.vars.trigger.closest('.feature-block')) {
      trigger.kill();
    }
  });

  document.querySelectorAll(".feature-block").forEach((block) => {

    setTimeout(() => {
      ScrollTrigger.refresh();
    }, 1000);


    // TWO IMAGES : parallax
    if (block.classList.contains('two-images')) {
      const firstImg = block.querySelector(".feature-block__images .img");
      if (!firstImg) return;

      const fromY = 20;
      const toY = -20;

      gsap.set(firstImg, { yPercent: fromY });

      gsap.to(firstImg, {
        yPercent: toY,
        ease: "none",
        scrollTrigger: {
          trigger: block,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
        },
      });
    }



    // HERO STYLE : parallax
    if (block.classList.contains('feature-block--hero')) {

      const wrap = block.querySelector(".feature-block__image");
      const img = wrap && wrap.querySelector("img");
      if (!wrap || !img) return;

      gsap.set(img, { scale: 1.24, willChange: "transform" });

      const from = 12;
      const to = -12;

      gsap.set(img, { yPercent: from });

      gsap.to(img, {
        yPercent: to,
        ease: "none",
        scrollTrigger: {
          trigger: block,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
          invalidateOnRefresh: true
        },
      });
    }

  });

}
